// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content.gridster-item-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

app-builds {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/builds-widget/builds-widget.component.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,OAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAAF","sourcesContent":["// Ensure app-builds fills the content area and uses flex layout\n.content.gridster-item-content {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\napp-builds {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
